import styled from "styled-components";

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export default FlexColumn;



// WEBPACK FOOTER //
// ./src/components/FlexColumn.js